import { state } from './state'
import actions from './actions'

const mutations = {
  setMyFollowedUser(state, data) {
    state.myFollowedUser = data
  },
  setMyFollowedTopic(state, data) {
    state.myFollowedTopic = data
  },
}

const getters = {
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
